export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8137.8959b8e2.jpg";